import { gql } from "@apollo/client";
import {
  EMAIL_BRAND_THEME_FIELDS,
  EMAIL_TEMPLATE_FIELDS,
  EMAIL_TEMPLATE_SUMMARY_FIELDS,
  TRAVEL_AIRLINE_FIELDS,
} from "./fragments";

export const GET_TRAVEL_EMAIL_TEMPLATES = gql`
  query GetTravelEmailTemplates(
    $searchTerm: String
    $subtype: NotificationTemplateSubtype
    $classification: NotificationClassification
    $includeInactive: Boolean! = false
    $pageSize: Int! = 50
    $pageNumber: Int! = 0
  ) {
    travelEmailTemplates(
      searchTerm: $searchTerm
      subtype: $subtype
      classification: $classification
      includeInactive: $includeInactive
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      count
      pageSize
      pageNumber
      items {
        ${EMAIL_TEMPLATE_SUMMARY_FIELDS}
      }
    }
  }
`;

export const GET_TRAVEL_EMAIL_TEMPLATE = gql`
  query GetTravelEmailTemplate($id: String!) {
    travelEmailTemplate(id: $id) {
      ${EMAIL_TEMPLATE_FIELDS}
    }
  }
`;

export const GET_TRAVEL_EMAIL_TEMPLATE_VARIABLES = gql`
  query GetTravelEmailTemplateVariables(
    $subtype: NotificationTemplateSubtype!
    $classification: NotificationClassification! = NON_TRANSACTIONAL
  ) {
    travelEmailTemplateVariables(subtype: $subtype, classification: $classification) {
      id
      token
      group
      sample
      availability
    }
  }
`;

export const GET_TRAVEL_EMAIL_TEMPLATE_PREVIEW = gql`
  query GetTravelEmailTemplatePreview($request: NotificationTemplatePreviewRequestInput!) {
    travelEmailTemplatePreview(request: $request) {
      id
      subject
      html
      missingVariables
      unknownVariables
    }
  }
`;

export const GET_TRAVEL_EMAIL_BRAND_THEME = gql`
  query GetTravelEmailBrandTheme {
    travelEmailBrandTheme {
      ${EMAIL_BRAND_THEME_FIELDS}
    }
  }
`;

export const GET_TRAVEL_AIRLINES = gql`
  query GetTravelAirlines(
    $searchTerm: String
    $includeInactive: Boolean! = false
    $pageSize: Int! = 50
    $pageNumber: Int! = 0
  ) {
    travelAirlines(
      searchTerm: $searchTerm
      includeInactive: $includeInactive
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      count
      pageSize
      pageNumber
      items {
        ${TRAVEL_AIRLINE_FIELDS}
      }
    }
  }
`;
